import CreateProductContainer from "@containers/dashboard/products/create";
import DashboardLayout from "@layouts/dashboard";

const CreateProduct = () => {
    return (
        <DashboardLayout title="محصول جدید">
            <CreateProductContainer />
        </DashboardLayout>
    );
};

export default CreateProduct;
